import {Component, Input, OnChanges, OnDestroy, OnInit, Renderer2, SimpleChanges} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';
import * as Moment from 'moment-timezone';
import {Subject} from 'rxjs';
import {take, takeUntil, tap} from 'rxjs/operators';
import {ScreenService} from '../../../../../shared/services/general';
import {OrdersService} from '../../../../shared/services/orders.service';
import {MicrobiologyResult, ResultType, TestStatus} from '../../models/results';

@Component({
    selector: 'app-microbiology-results',
    templateUrl: './microbiology-results.component.html',
    styleUrls: ['./microbiology-results.component.scss'],
})
export class MicrobiologyResultsComponent implements OnInit, OnDestroy, OnChanges {
    @Input() public orderId: number = -1;
    public isLoading = false;
    public pureMicResults: MicrobiologyResult[] = [];
    public alphaMicResults: any[] = [];
    public expandedKeys: any[] = [];
    public rowOperation = false;
    public isPhoneOrTablet: boolean = false;
    private onDestroy$: Subject<void> = new Subject<void>();

    constructor(private orderService: OrdersService, private screen: ScreenService, private renderer: Renderer2, private sanitizer: DomSanitizer) {
    }

    public calculateNameFilter(value: any, selectedFilterOperations: any, target: any) {
        const column = this as any;
        if (target === 'filterRow') {
            return [['name', 'contains', value.toUpperCase()]];
        }
        return column.defaultCalculateFilterExpression.apply(this, arguments);
    }

    public ngOnInit() {
        this.isLoading = true;

        this.orderService.getMicrobiologyResults(this.orderId)
            .pipe(
                take(1),
                tap(r => this.pureMicResults = r.filter(x => x.resultType === ResultType.Microbiology)),
                tap(r => this.alphaMicResults = r.filter(x => x.resultType === ResultType.AlphaMicrobiology))
            )
            .subscribe(() => this.expandedKeys = this.alphaMicResults.map(r => r.key));

        this.isPhoneOrTablet = this.screen.sizes['screen-x-small'] || this.screen.sizes['screen-small'] || this.screen.sizes['screen-tablet'];
        this.screen.changed.pipe(takeUntil(this.onDestroy$)).subscribe(() => {
            this.isPhoneOrTablet = this.screen.sizes['screen-x-small'] || this.screen.sizes['screen-small'] || this.screen.sizes['screen-tablet'];
        });
    }

    public status(status: TestStatus, preliminaryReleased: boolean): string {
      if (preliminaryReleased) return TestStatus[TestStatus.Preliminary].toUpperCase();
      return status == TestStatus.Unreleased ? TestStatus[TestStatus.Pending].toUpperCase() : TestStatus[status].toUpperCase();
    }

    public formatDate(date?: Date) {
      if (date == null) return '';

      const parsedDate = Moment(date);

      if (parsedDate.isValid() && parsedDate.isAfter('1900-01-01'))
        return Moment(date).format('MM/DD/YYYY');
      return '';
    }


    public viewerReady(element: any) {
        this.renderer.removeClass(element.element, 'dx-state-disabled');
    }

    public transformYourHtml(htmlTextWithStyle: string) {
        return this.sanitizer.bypassSecurityTrustHtml(htmlTextWithStyle);
    }

    public ngOnDestroy(): void {
        this.onDestroy$.next();
        this.onDestroy$.complete();
    }

  public ngOnChanges(changes: SimpleChanges): void {
      if (changes.orderId.currentValue) {
        this.isLoading = true;

        this.orderService.getMicrobiologyResults(changes.orderId.currentValue)
          .pipe(
            take(1),
            tap(r => this.pureMicResults = r.filter(x => x.resultType === ResultType.Microbiology)),
            tap(r => this.alphaMicResults = r.filter(x => x.resultType === ResultType.AlphaMicrobiology))
          )
          .subscribe(() => this.expandedKeys = this.alphaMicResults.map(r => r.key));
      }
  }
}
